import React, { useEffect, useState } from 'react';
import { ImagePlus } from 'lucide-react';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';
import iconAddCategory from '../assets/screens/icon-add-category.png';

const CHIP_SWITCH_INTERVAL = 3200;

/**
 * Prévia do fluxo real de criar categoria/rotina do app
 * (`fragment_config_create.xml`, tela "ConfigCreate"): foto, campo de nome,
 * escolha entre categoria ou rotina, e botão salvar — mesma ordem e mesmos
 * textos ("Adicione um nome...", "Escolha salvar em uma categoria ou
 * rotina", "Salvar").
 */
export function CreateCategoryCard() {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [selectedChip, setSelectedChip] = useState<'categoria' | 'rotina'>('categoria');

  useEffect(() => {
    if (prefersReducedMotion) return;
    const timer = setInterval(() => {
      setSelectedChip((c) => (c === 'categoria' ? 'rotina' : 'categoria'));
    }, CHIP_SWITCH_INTERVAL);
    return () => clearInterval(timer);
  }, [prefersReducedMotion]);

  return (
    <div className="rounded-2xl overflow-hidden bg-card shadow-lg" aria-hidden="true">
      {/* Foto — igual ao imagePreview do app */}
      <div className="h-28 border-b-2 border-dashed border-border flex flex-col items-center justify-center gap-1.5 bg-muted/40">
        <img src={iconAddCategory} alt="" className="w-10 h-10" />
        <span className="text-xs font-medium text-muted-foreground">Adicionar foto</span>
      </div>

      <div className="p-4 space-y-3">
        {/* Campo de nome — igual ao editTextName ("Adicione um nome...") */}
        <div className="rounded-lg border border-border px-3 py-2.5 text-sm text-muted-foreground">
          Adicione um nome...
        </div>

        <div className="border-t border-border pt-3">
          <p className="text-xs text-center text-muted-foreground mb-2.5">
            Escolha salvar em uma categoria ou rotina
          </p>
          <div className="flex items-center justify-center gap-2">
            <span
              className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors ${
                selectedChip === 'categoria' ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
              }`}
            >
              Categoria
            </span>
            <span
              className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors ${
                selectedChip === 'rotina' ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'
              }`}
            >
              Rotina
            </span>
          </div>
        </div>

        {/* Botão salvar — igual ao "save" do app */}
        <div className="flex items-center justify-center gap-2 rounded-lg bg-primary text-white text-sm font-bold py-2.5">
          <ImagePlus className="w-4 h-4" />
          Salvar
        </div>
      </div>
    </div>
  );
}
